import { gql } from '@apollo/client';

export const CAR_SPECS_FIND_TRIM = gql`
  query CarSpecsFindTrim($filters: [FilterParam!]) {
    carSpecsFind(filters: $filters) {
      id
      trim
    }
  }
`;

export const CAR_SPECS_FIND_TRIM_SPECS = gql`
  query CarSpecsFindTrimSpecs($filters: [FilterParam!]) {
    carSpecsFindOne(filters: $filters) {
      bodyType
      cylinderType
      doorType
      drivetrainType
      fuelType
      transmissionType
    }
  }
`;
